import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSupportCategories,
  fetchSupportTypes,
  fetchSupportKbItems,
  searchSupportKbItems,
  getSupportKbItemById,
  createSupportKbItem,
  updateSupportKbItem,
  activateSupportKbItem,
  deactivateSupportKbItem,
  deleteSupportKbItem
} from "../Action/SupportKbAction";

const supportKbSlice = createSlice({
  name: "supportKb",
  initialState: {
    items: [],
    totalItems: 0,
    categories: [],
    types: [],
    searchResults: [],
    selectedItem: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSearchResults: (state) => {
      state.searchResults = [];
    },
    clearSelectedItem: (state) => {
      state.selectedItem = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // fetchSupportCategories
      .addCase(fetchSupportCategories.fulfilled, (state, action) => {
        state.categories = action.payload || [];
      })
      // fetchSupportTypes
      .addCase(fetchSupportTypes.fulfilled, (state, action) => {
        state.types = action.payload || [];
      })
      // fetchSupportKbItems
      .addCase(fetchSupportKbItems.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSupportKbItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data || [];
        state.totalItems = action.payload.totalItems || 0;
      })
      .addCase(fetchSupportKbItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // searchSupportKbItems
      .addCase(searchSupportKbItems.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchSupportKbItems.fulfilled, (state, action) => {
        state.loading = false;
        state.searchResults = action.payload || [];
      })
      .addCase(searchSupportKbItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // getSupportKbItemById
      .addCase(getSupportKbItemById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupportKbItemById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedItem = action.payload;
      })
      .addCase(getSupportKbItemById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // createSupportKbItem
      .addCase(createSupportKbItem.fulfilled, (state, action) => {
        if (action.payload) {
          state.items.unshift(action.payload);
          state.totalItems += 1;
        }
      })
      // updateSupportKbItem
      .addCase(updateSupportKbItem.fulfilled, (state, action) => {
        if (action.payload) {
          const index = state.items.findIndex(i => i._id === action.payload._id);
          if (index !== -1) {
            state.items[index] = action.payload;
          }
          const sIndex = state.searchResults.findIndex(i => i._id === action.payload._id);
          if (sIndex !== -1) {
            state.searchResults[sIndex] = action.payload;
          }
          if (state.selectedItem?._id === action.payload._id) {
            state.selectedItem = action.payload;
          }
        }
      })
      // activateSupportKbItem / deactivateSupportKbItem
      .addCase(activateSupportKbItem.fulfilled, (state, action) => {
        if (action.payload) {
          const index = state.items.findIndex(i => i._id === action.payload._id);
          if (index !== -1) {
            state.items[index] = action.payload;
          }
          const sIndex = state.searchResults.findIndex(i => i._id === action.payload._id);
          if (sIndex !== -1) {
            state.searchResults[sIndex] = action.payload;
          }
        }
      })
      .addCase(deactivateSupportKbItem.fulfilled, (state, action) => {
        if (action.payload) {
          const index = state.items.findIndex(i => i._id === action.payload._id);
          if (index !== -1) {
            state.items[index] = action.payload;
          }
          const sIndex = state.searchResults.findIndex(i => i._id === action.payload._id);
          if (sIndex !== -1) {
            state.searchResults[sIndex] = action.payload;
          } else {
            state.searchResults = state.searchResults.filter(i => i._id !== action.payload._id);
          }
        }
      })
      // deleteSupportKbItem
      .addCase(deleteSupportKbItem.fulfilled, (state, action) => {
        const { id, permanent } = action.payload;
        if (permanent) {
          state.items = state.items.filter(i => i._id !== id);
          state.searchResults = state.searchResults.filter(i => i._id !== id);
          state.totalItems = Math.max(0, state.totalItems - 1);
        } else {
          const index = state.items.findIndex(i => i._id === id);
          if (index !== -1) {
            state.items[index].is_active = false;
          }
          const sIndex = state.searchResults.findIndex(i => i._id === id);
          if (sIndex !== -1) {
            state.searchResults[sIndex].is_active = false;
          }
        }
      });
  },
});

export const { clearSearchResults, clearSelectedItem } = supportKbSlice.actions;
export default supportKbSlice.reducer;
